module.exports = __webpack_public_path__ + "static/media/spam-scam.c7d361c9.svg";